import '../styles';

import {
  MessageButtons,
  MessageFollowUpOption,
  SENDER,
  SplitBillResult,
} from '../interfaces';

import {BotMessageBubble} from './BotMessageBubble';
import {UserMessageBubble} from './UserMessageBubble';

type Props = {
  text: string;
  from: SENDER.USER | SENDER.BOT;
  result?: boolean;
  splitBill?: SplitBillResult;
  onButtonPress?: () => void;
  onClearConversationPress?: () => void;
  onSplitAdd?: () => void;
  onSplitUndo?: () => void;
  isCreatingSplit?: boolean;
  splitCreateError?: boolean;
  isSplitAdded?: boolean;
  filePreview?: string | null;
  showSupport?: boolean;
  onButtonSupportPress?: () => void;
  onButtonWalkThroughPress?: () => void;
  isSupportLoading?: boolean;
  buttons?: MessageButtons;
  onButtonLinkPress?: (link: string) => void;
  onFollowUpOptionPress?: (option: MessageFollowUpOption) => void;
  selectedInMessageOption?: string;
};

export const MessageBubble = ({
  text,
  from,
  result,
  splitBill,
  onButtonPress,
  onClearConversationPress,
  onSplitAdd,
  onSplitUndo,
  isCreatingSplit,
  splitCreateError,
  isSplitAdded,
  showSupport,
  onButtonSupportPress,
  onButtonWalkThroughPress,
  filePreview,
  isSupportLoading,
  buttons,
  onButtonLinkPress,
  onFollowUpOptionPress,
  selectedInMessageOption,
}: Props) => {
  return from === SENDER.BOT ? (
    <BotMessageBubble
      text={text}
      onButtonPress={onButtonPress}
      onClearConversationPress={onClearConversationPress}
      onSplitAdd={onSplitAdd}
      onSplitUndo={onSplitUndo}
      isCreatingSplit={isCreatingSplit}
      splitCreateError={splitCreateError}
      isSplitAdded={isSplitAdded}
      result={result}
      splitBill={splitBill}
      showSupport={showSupport}
      onButtonSupportPress={onButtonSupportPress}
      onButtonWalkThroughPress={onButtonWalkThroughPress}
      isSupportLoading={isSupportLoading}
      buttons={buttons}
      onButtonLinkPress={onButtonLinkPress}
      onFollowUpOptionPress={onFollowUpOptionPress}
      selectedInMessageOption={selectedInMessageOption}
    />
  ) : (
    <UserMessageBubble
      text={text}
      filePreview={filePreview}
    />
  );
};
